export default __webpack_public_path__ + "static/media/img (2).79d4a5fc.jpg";